import { useEffect, useState } from "react";
import { ApolloCache, useApolloClient, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { GET_ORG_POSITIONS, GET_POSITION_DETAIL, GET_ORG_ROLES, GET_ORGS_BY_POSITIONS} from "../../../../graphql/position-gql";
import { CancelIcon, DeleteIcon, PauseIcon, PencilIcon, PlayIcon } from "../../../common/icons";
import Info from '../../../common/info';
import DateFormat from "../../../common/date-format";
import { fullNameAutoFormat } from "../../../../utils/format-fullname";
import { ORG_VALUE_LISTS } from "../../../../graphql/valuelist-gql";
import { IValueListLight } from "../../../../types/valuelist";
import useToggle from "../../../../hook/useToggle";
import { notifySuccess } from "../../../../services/notification";
import UpdateDeactivationReasonModal from "./update-deactivation-reason";
import DeactivateAssignmentModal from "./deactivate-assignment";
import confirm from "../../../common/confirm";
import { Action, IAssignIndividualInput, IIndividual, IIndividualActingLinkAssignmentResponse, IPositionAssignmentLight, IUpdateResultResponse } from "../../../../types/individual";
import { IPosition } from "../../../../types/position";
import { ASSIGN_INDIVIDUAL, INDIVIDUAL_ACTING_LINK_ASSIGNMENT } from "../../../../graphql/individual-gql";
import removeActingLink from "./remove-ActingLink";
import { REMOVE_ACTING_LINK } from '../../../../graphql/position-gql';
import SpinnerOverlay from "../../../common/spinner/spinner";
import { GET_ORG_DETAILS } from "../../../../graphql/org-gql";
import useScope from "../../../../hook/useScope";
import useAuth from "../../../../hook/useAuth";
import RemoveActingLinkDialog from "./remove-ActingLink";
import { IOrgResponse } from "../../../../types/org";
import Button from "../../../common/button";

type HomePositionIndividualProp = {
    position:IPosition

}
const HomePositionIndividual = (prop:HomePositionIndividualProp) => {

  const {position} = prop;

  const [indi,SetIndi] = useState<IIndividual>()
  const [reasonId,setReasonId] = useState<number>(0)
  const { isOpen : isDeactivateOpen, toggle : deactivateToggle } = useToggle()
  const { isOpen: isReasonUpdateOpen, toggle: reasonUpdatetoggle } = useToggle();
  const { isOpen: isRemoveActingLinkOpen, toggle: removeActingLinktoggle } = useToggle();
  const isScope = useScope(position?.orgId||0,false);

  const [assignIndividual,{loading:assignLoading}] = useMutation<IUpdateResultResponse>(ASSIGN_INDIVIDUAL);
  const [removeActingLinkClient,{loading:removeActingLinkLoading}] = useMutation(REMOVE_ACTING_LINK)
  const {data, loading:getActingLinkLoading} = useQuery<IIndividualActingLinkAssignmentResponse>(INDIVIDUAL_ACTING_LINK_ASSIGNMENT, {
    variables:{individualId:indi?.individualId||0},
    fetchPolicy:"network-only"
  });
  const [getOrgsByPositions,{loading:getOrgIdsLoading}] = useLazyQuery(GET_ORGS_BY_POSITIONS)

  const client = useApolloClient()
  const { orgValueLists } =  client.readQuery({query: ORG_VALUE_LISTS})
  const { isFrenchTranslator } = useAuth();
  const [getOrgDetails,{data:orgDetailsResponse}] = useLazyQuery<IOrgResponse>(GET_ORG_DETAILS);
  const [cloned,setCloned] = useState<boolean>(false);

  useEffect(()=>{
    //console.log("position:",position)
    setCloned(!!position?.shareLinkId)
    if(position?.orgId) getOrgDetails({ variables: { id:position.orgId}} );
  },[position])
  
  useEffect(()=>{
    const homeIndi = position?.individuals?.filter(indi=>indi.relType.code === 'DIRECT'|| indi.relType.code === 'DIRECT_SHARE');
    if(homeIndi&&homeIndi.length!==0) SetIndi(homeIndi[0])
    else SetIndi(undefined)

    //console.log('position:',position)

  },[position])

  useEffect(()=>{
    indi && setReasonId(indi.indStatusReason?.id||0)
    //indi?.individualId && getIndividualActingLinkAssignment()
  },[indi])

  //const getRefetchQuery = () => {return [{query: GET_POSITION_DETAIL, variables: { positionId: position.positionId}}]}

  const updatCache = (cache : ApolloCache <any>, result: any, indi?:IIndividual) =>{
    const cachedOrg = cache.readQuery<{
      org:{
          positions:Array<IPosition>
      }
    }>({
      query: GET_ORG_POSITIONS,
      variables: { orgId: position?.orgId},
    });

    if(cachedOrg){

        let updatedPositions = [...cachedOrg.org.positions];
        const updatedPositionIndex = updatedPositions.findIndex(
            (pos: IPosition) => pos.positionId === position.positionId
          );

        if (updatedPositionIndex !== -1) {
            const indiIndex = updatedPositions[updatedPositionIndex].individuals.findIndex(
              (individual:IIndividual) => individual.individualId === indi?.individualId
            )
            if(indiIndex!==-1){

                let updatedIndividuals = [...updatedPositions[updatedPositionIndex].individuals]

                if(indi){
                  updatedIndividuals[indiIndex]=indi;
                }else{
                  updatedIndividuals.splice(indiIndex, 1);
                }

                updatedPositions[updatedPositionIndex]={
                  ...updatedPositions[updatedPositionIndex],
                  individuals: updatedIndividuals
                };

            }
        }
        // Update the cached data with the modified positions array
        cache.writeQuery({
            query: GET_ORG_POSITIONS,
            variables: { orgId:  position?.orgId },
            data: {
                org: {
                    ...cachedOrg.org,
                    positions: updatedPositions,
                },
            },
        });

    }
    SetIndi(indi);
  }

  const onRemoveIndividualHandle = ()=>{

    const input:IAssignIndividualInput = {assignmentId:indi?.positionAssignmentId}
    //console.log("input:",input)
    assignIndividual({variables:{positionId:position?.positionId,action:Action.REMOVAL_VALIDATION,input:input}}).then((removalValidationResponse)=>{
      if(removalValidationResponse.data?.assignIndividual)
        handleValidationError(removalValidationResponse.data.assignIndividual.message)
      else
        handleRemovalConfirmation(input).then(() => {
          handleRemovalAutomation(input);
        });
    })

  }

  const handleValidationError = (errorMessage: string) => {
    confirm({
      title: 'Warning!',
      content: errorMessage,
      titleCenter: true,
      bodyCenter: true,
      showCancel: false,
      okText: 'Close',
      okIcon:<CancelIcon/>
    });
  };

  const handleRemovalConfirmation = (input: IAssignIndividualInput) => {
    const fullName = fullNameAutoFormat(indi?.firstName, indi?.middleName, indi?.lastName);
    return confirm({
      title: 'Warning!',
      content: `Are you sure you want to remove <b>${fullName}</b> from the <b>${position.fullPositionName}</b> home position?`,
      titleCenter: true,
      bodyCenter: true,
      showCancel: true,
      okText: 'Remove',
      okBtnColor: 'danger',
      okIcon: <DeleteIcon />
    })
  };

  const handleRemovalAutomation = (input: IAssignIndividualInput) => {
    assignIndividual({variables:{positionId:position?.positionId,action:Action.REMOVAL_AUTOMATION,input:input}}).then((removeAutomationResponse:any)=>{
      if(removeAutomationResponse.data?.assignIndividual){
        const confirmContent = removeAutomationResponse.data?.assignIndividual.message;
        confirm({
          title: 'Remove Position Assignment?',
          content: confirmContent,
          okText: <><DeleteIcon/> Remove</>,
          okBtnColor: 'danger',
          titleCenter:true,
          bodyCenter:true
        }).then( () => {
          removalAssignmentExecute(input)
        })
      }else{
        removalAssignmentExecute(input)
      }
    })

  }

  const removalAssignmentExecute =async (input:IAssignIndividualInput) => {
    if(data?.individualActingLinkAssignment){
      removeActingLinktoggle()
    }else{
      removalSelectedtAssignmentExecute(input)
    }
  }

  const removalSelectedtAssignmentExecute = (input:IAssignIndividualInput) =>{
    assignIndividual({
      variables:{positionId:position?.positionId,action:Action.REMOVAL,input:input},
      refetchQueries:removalSelectedtAssignmentRefetchQueries(),
      awaitRefetchQueries: true,
      onCompleted(data) {
        data?.assignIndividual?.success && notifySuccess()
        SetIndi(undefined)
      }
    })
  }

  const removalSelectedtAssignmentRefetchQueries = () =>{
    let queries : any =[{query: GET_POSITION_DETAIL,variables: { positionId:position.positionId }},{query: GET_ORG_POSITIONS,variables: { orgId:  position?.orgId }}];
    
    return queries;
  }

  const removalActingLinkAssignmentExecute = async (response:IPositionAssignmentLight[],input:IAssignIndividualInput) => {
    const positionIds = Array.from(new Set(response.map(assignment=>assignment.positionId)))
    const orgResponse = await getOrgsByPositions({variables:{positionIds}})

    removeActingLinkClient({
      variables:{positionId:position.positionId||0,positionAssignmentIds:response.map(item=>item.assignmentId)},
      onCompleted(data){
        data?.removeActingLink && removalSelectedtAssignmentExecute(input)
      },
      refetchQueries:removalActingLinkRefetchQueries(orgResponse?.data.orgsByPositions,positionIds),
      awaitRefetchQueries: true
    })

  }

  const reactivateAssignmentExecute = (input:IAssignIndividualInput) => {
    assignIndividual({
      variables: {
        positionId:position?.positionId,
        action: Action.ACTIVATION,
        input:input
      },
      update(cache,{data}){
        if(data?.assignIndividual?.success && indi){
          const updatedIndi:IIndividual = {...indi,indStatus:'Active'}
          updatCache(cache,data,updatedIndi)
        }
      },
      refetchQueries: [
          {
              query: GET_POSITION_DETAIL,
              variables: { positionId:position.positionId }
          },
          {
            query: GET_ORG_POSITIONS,
            variables: { orgId:  position?.orgId}
          }
      ],
      awaitRefetchQueries: true,
      onCompleted(data) {
        data?.assignIndividual?.success && notifySuccess()
      },
    })
  }

  const removalActingLinkRefetchQueries = (orgIds:number[],positionIds:number[]) => {
    let queries:any = []

    if(orgIds!==undefined&&orgIds.length>0){
      orgIds.forEach(orgId=>queries.push({
        query: GET_ORG_POSITIONS,
        variables: { orgId }
      }))
    }
    if(positionIds!==undefined&&positionIds.length>0){
      positionIds.forEach(positionId=>queries.push({
        query: GET_POSITION_DETAIL,
        variables: { positionId }
      }))
    }



    return queries

  }

  const reactivateAssignment = ()=>{
    const input:IAssignIndividualInput = {assignmentId:indi?.positionAssignmentId}
    assignIndividual({variables:{positionId:position?.positionId,action:Action.ACTIVATION_VALIDATION,input:input}}).then((validationResponse)=>{
      if(!validationResponse?.data?.assignIndividual){
        assignIndividual({variables:{positionId:position?.positionId,action:Action.ACTIVATION_AUTOMATION,input:input}}).then((automationResponse)=>{
          if(automationResponse.data?.assignIndividual?.message){
            const confirmContent =automationResponse.data.assignIndividual.message;
            confirm({
              title: 'Remove Position Assignment?',
              content: confirmContent,
              okText: <><DeleteIcon/> Remove</>,
              okBtnColor: 'danger',
              titleCenter:true,
              bodyCenter:true
            }).then( () => { reactivateAssignmentExecute(input) })
          }else{
            reactivateAssignmentExecute(input)
          }
        })
      }else{
        confirm({
          title: 'Warning!',
          content:  validationResponse.data.assignIndividual.message,
          titleCenter: true,
          bodyCenter: true,
          showCancel: false,
          okText: 'Close',
          okIcon:<CancelIcon/>
        })
      }
    })
  }

  const onDeactivateReactivateHandler =() => {
    if(indi?.indStatus!=='Active'){
      reactivateAssignment()
    }else{
      deactivateToggle()
    }
  }
  const onUpdateReasonHandler = (selectedReasonId:number) => {
    //console.log("reasonId:",reasonId)
    if(selectedReasonId!==reasonId){
      assignIndividual({
        variables:{positionId:position?.positionId,action:Action.UPDATE_REASON,input:{assignmentId:indi?.positionAssignmentId,reasonId:selectedReasonId}},
        update(cache,{data}){
          if(data?.assignIndividual.success&&indi){
            const selectReason = orgValueLists.posStatusReason.filter((valueList: IValueListLight)=>valueList.id===selectedReasonId)[0];
            const updatedIndi:IIndividual = {...indi,indStatus:'Inactive',indStatusReason:{...selectReason}}
            updatCache(cache,data,updatedIndi)
          }
        },onCompleted(data){
          data?.assignIndividual.success&&notifySuccess()
        }
      })
      setReasonId(selectedReasonId)
      reasonUpdatetoggle();
    }
  }
  const onDeactivateConfirm = (id?:any) =>{

    const input:IAssignIndividualInput = {assignmentId:indi?.positionAssignmentId,reasonId:id}

    assignIndividual({
      variables:{positionId:position?.positionId,action:Action.DEACTIVATION,input:input},
      update(cache,{data}){
        if(data?.assignIndividual && indi){
          const selectReason = orgValueLists.posStatusReason.filter((valueList: IValueListLight)=>valueList.id===id)[0];
          const updatedIndi:IIndividual = {...indi,indStatus:'Inactive',indStatusReason:{...selectReason}}
          updatCache(cache,data,updatedIndi)
        }
      },onCompleted(data){
        data&&notifySuccess()
      }
    })

    setReasonId(id)
  }

  const handleKeyDown = (event: any) => {
    // Check if Enter or Space key is pressed
    if (event.key === 'Enter' || event.key === ' ') {
      reasonUpdatetoggle();
    }
}

const onRemoveHandle = (assignments:IPositionAssignmentLight[]) =>{
    const input:IAssignIndividualInput = {assignmentId:indi?.positionAssignmentId}
    if(assignments.length>0)
      removalActingLinkAssignmentExecute(assignments,input)
    else
      removalSelectedtAssignmentExecute(input);
}


  return (
    <div role="region" aria-label="Individual Information" >
      {(assignLoading||getActingLinkLoading||removeActingLinkLoading||getOrgIdsLoading)&&<SpinnerOverlay />}
      {indi && <DeactivateAssignmentModal isOpen={isDeactivateOpen} toggle={deactivateToggle}
        onConfirm={onDeactivateConfirm}
        individual={indi}
        fullPositionName={position?.fullPositionName}
        reasonList={orgValueLists.posStatusReason}
      />}
      {<UpdateDeactivationReasonModal
        isOpen={isReasonUpdateOpen}
        toggle={reasonUpdatetoggle}
        indi={indi}
        updateHandler={onUpdateReasonHandler}
        posStatusReasonList={orgValueLists.posStatusReason||[]}></UpdateDeactivationReasonModal>}
      {
        <RemoveActingLinkDialog
          fullPositionName={position.fullPositionName} 
          individualName={fullNameAutoFormat(indi?.firstName,indi?.middleName,indi?.lastName)} 
          isOpen={isRemoveActingLinkOpen} 
          onRemove={onRemoveHandle} 
          toggle={removeActingLinktoggle} 
          list={data?.individualActingLinkAssignment||[]} 
          title='Remove Individual From Positions' />
      }
      {(!indi)&&
        <Info>There is no one currently assigned to this home position.</Info>

      }
      {(indi)&&
        <>
          {!isFrenchTranslator &&
          <>
            <Button color="danger" style={{ marginRight: '15px' }} onClick={onRemoveIndividualHandle} disabled={!isScope||cloned}>
              <DeleteIcon /> Remove Individual
            </Button>
            <Button color="primary" outline style={{ marginRight: '15px' }} onClick={onDeactivateReactivateHandler} disabled={!isScope||cloned}>
                  {indi.indStatus==='Active' && (<><PauseIcon alt="Deactivate icon"/>&nbsp;Deactivate Assignment</>)}
                  {indi.indStatus!=='Active' && (<><PlayIcon  alt="Reactivate icon"/>&nbsp;Reactivate Assignment</>)}
            </Button>
          <br/><br/>
          </>
        }
          <div className='row'>
            <div className="col-md-6 flex-container" >
              <div className="flex-item">
                <div style={{fontWeight:"bold"}}>Individual Name:</div>
                <div style={{fontWeight:"bold"}}>Related Organization:</div>
              </div>
              <div className="flex-item">
                <div id="homename"  >{fullNameAutoFormat(indi?.firstName,indi?.middleName,indi?.lastName)}</div>
                <div id="homerelatedOrg" >{orgDetailsResponse?.org?.orgName||' '}</div>
              </div>
            </div>
            <div className="col-md-6 flex-container">
              <div className="flex-item">
                <div style={{fontWeight:"bold"}}>Start Date:</div>
                {indi.indStatus!=='Active' &&<div style={{fontWeight:"bold"}}>Deactivation Reason:</div>}
              </div>
              <div className="flex-item">
                <div id="homestartDate" ><DateFormat date={indi?.startDate ? indi.startDate: "No Date"}></DateFormat></div>
                {indi.indStatus!=='Active' &&
                  <div id="homereason" style={{display:"flex"}}>{orgValueLists.posStatusReason.filter((valueList: IValueListLight)=>valueList.id===reasonId)[0]?.label}&nbsp;
                     {!isFrenchTranslator 
                      && <div onClick={()=>{reasonUpdatetoggle()}} 
                            className={`${cloned ? 'disabled' : ''}`}
                            role="button" tabIndex={0} 
                            onKeyDown={event=>handleKeyDown(event)} 
                            aria-label="edit deactivate reason"> <PencilIcon alt="edit deactivate reason" />
                        </div>}
                  </div>}
              </div>
            </div>
          </div>
        </>
      }
    </div>)
}

export default HomePositionIndividual
